import * as React from 'react';
import classnames from 'classnames';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { isSubscriptionPurchase } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';
import { SolutionsDeliveryIntervalSelect } from '../SolutionsDeliveryIntervalSelect/SolutionsDeliveryIntervalSelect.js';
import { SolutionsPurchaseTypeSelectionBoxes } from '../SolutionsPurchaseTypeSelectionBoxes/SolutionsPurchaseTypeSelectionBoxes.js';

const SolutionsSubscriptionPurchase = ({ className  })=>{
    const { activeVariant  } = useProductDetailContext();
    const { state  } = useSolutionsEcommContext();
    const { purchaseType  } = state.configurations;
    if (!CommerceToolsApi.isSolutions(activeVariant) || !activeVariant.isAvailableForSubscription) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('solutions-subscription-purchase', className)
    }, /*#__PURE__*/ React.createElement(SolutionsPurchaseTypeSelectionBoxes, {
        className: "solutions-subscription-purchase__purchase-type"
    }), isSubscriptionPurchase(purchaseType) && /*#__PURE__*/ React.createElement(SolutionsDeliveryIntervalSelect, {
        className: "solutions-subscription-purchase__delivery-interval"
    }));
};

export { SolutionsSubscriptionPurchase };
//# sourceMappingURL=SolutionsSubscriptionPurchase.js.map
